'use client';
import { MultiServicePreset } from '@/types';

import { useEffect, useState } from 'react';
import { getAllMultiTexts, getTextData } from '@/services/server/text';
import { SERVICE_TYPES } from '@/helpers/enums';
import Hero from './Hero';
import { CardDefinition, ContentType, TextNumber } from '@/types';
import { useConfig } from '@/app/contexts/ConfigContext';
import TextContent from './TextContent';

interface AllTextPageProps {
  textNumber: TextNumber;
}

export default function AllTextPage({ textNumber }: AllTextPageProps) {
  const [items, setItems] = useState<CardDefinition[]>([]);
  const { selectedLanguage, config, setConfig, updateWording } = useConfig();

  const textContentType = config.contents[textNumber] as ContentType;
  const forcedTextServiceType =
    textNumber === 'text1' && config.multiService === MultiServicePreset.AML
      ? SERVICE_TYPES.MEDITATION
      : null;

  useEffect(() => {
    if (
      forcedTextServiceType &&
      config.serviceType !== forcedTextServiceType
    ) {
      setConfig({
        ...config,
        serviceType: forcedTextServiceType,
      });
      updateWording(forcedTextServiceType, selectedLanguage);
    }
  }, [
    config,
    forcedTextServiceType,
    selectedLanguage,
    setConfig,
    updateWording,
  ]);

  useEffect(() => {
    const multiServiceTypes = config.multiServiceTypes;

    const fetchData = () => {
      try {
        const items = getTextData(
          config.serviceType,
          selectedLanguage,
          textContentType,
          textNumber
        );
        setItems(items);
      } catch (error) {
        console.error('[AllTextPage] Failed to fetch data:', error);
      }
    };

    const fetchMultiServicesData = () => {
      if (multiServiceTypes) {
        try {
          const items = getAllMultiTexts(
            multiServiceTypes,
            selectedLanguage,
            textContentType,
            textNumber
          );
          setItems(items);
        } catch (error) {
          console.error(
            '[AllTextPage] Failed to fetch all services text:',
            error
          );
        }
      }
    };

    multiServiceTypes ? fetchMultiServicesData() : fetchData();
  }, [
    config.multiService,
    config.multiServiceTypes,
    config.serviceType,
    selectedLanguage,
    textContentType,
    textNumber,
  ]);

  return (
    <main className='max-w-[1920px] mx-auto overflow-hidden'>
      <Hero textNumber={textNumber} />
      <TextContent items={items} textNumber={textNumber} />
    </main>
  );
}
